import { connect } from 'react-redux';
import StatusBar from '../../components/block_page/StatusBar';
import { getChangedFields } from '../../selectors/agent_settings';
import { saveSettings, resetSettings } from '../../actions/agent_settings';

const mapStateToProps = state => {
  const fields = getChangedFields(state);
  return {
    show: Boolean(fields.length),
    saving: state.agentSettings.saving,
    error: state.agentSettings.errors.join(', '),
  };
};

const mapDispatchToProps = dispatch => ({
  submitAction: () => {
    dispatch(saveSettings());
  },
  cancelAction: () => {
    dispatch(resetSettings());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusBar);
